import { type FirebaseOptions, initializeApp } from 'firebase/app';

import { env } from '../env';

const config: FirebaseOptions = {
	apiKey: env.NEXT_PUBLIC_FIREBASE_API_KEY,
	appId: env.NEXT_PUBLIC_FIREBASE_APP_ID,
	authDomain: env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
	databaseURL: env.NEXT_PUBLIC_FIREBASE_DATABASE_URL,
	measurementId: env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
	messagingSenderId: env.NEXT_PUBLIC_FIREBASE_SENDER_ID,
	projectId: env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
	storageBucket: env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET
};

export const initializeFirebase = () => initializeApp(config);
